import React, { FC } from 'react';
import { TypeSitemapFields } from '@/core/generated-types';
import SitemapColumn from './SitemapColumn';

const Sitemap: FC<TypeSitemapFields> = (props) => {
  if (!props) {
    return null;
  }

  const { column1, column2 } = props;

  return (
    <div className="grid px-4 pt-16 lg:grid-cols-2 lg:gap-8">
      <SitemapColumn components={column1} />
      <SitemapColumn components={column2} />
    </div>
  );
};

export default React.memo(Sitemap);
